<template>
  <OrganismModal
    v-model:is-shown="isModalOpen"
    data-cy="cashback-activation-conditions-modal"
    :title="t('subscription.cashbackActivation.conditionsModal.title')"
    size="lg"
    has-separator
    @cancel="handleClose"
  >
    <AtomText
      :text="tm('subscription.cashbackActivation.conditionsModal.content')[0]"
      font-size="text-sm"
      data-cy="cashback-activation-conditions-modal-content"
    />
    <br />
    <AtomText
      :text="tm('subscription.cashbackActivation.conditionsModal.content')[1]"
      font-size="text-sm"
      data-cy="cashback-activation-conditions-modal-content"
    />
    <ul class="list-disc ml-6">
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[2]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[3]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[4]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
    </ul>
    <br />
    <AtomText
      :text="tm('subscription.cashbackActivation.conditionsModal.content')[5]"
      font-size="text-sm"
      data-cy="cashback-activation-conditions-modal-content"
    />
    <ul class="list-disc ml-6">
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[6]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[7]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
      <AtomText
        is-tag="li"
        :text="tm('subscription.cashbackActivation.conditionsModal.content')[8]"
        font-size="text-sm"
        data-cy="cashback-activation-conditions-modal-content"
      />
    </ul>
    <br />
    <AtomText
      :text="tm('subscription.cashbackActivation.conditionsModal.content')[9]"
      font-size="text-sm"
      data-cy="cashback-activation-conditions-modal-content"
    />
    <br />
    <AtomText
      :text="tm('subscription.cashbackActivation.conditionsModal.content')[10]"
      font-size="text-sm"
      data-cy="cashback-activation-conditions-modal-content"
    />

    <template #footer="{ cancel }">
      <div class="flex justify-end max-sm:flex-col-reverse">
        <MoleculeButton
          data-cy="cashback-activation-conditions-modal-close-button"
          variant="tertiary"
          :label="t('subscription.cashbackActivation.conditionsModal.close')"
          @click="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['update:isOpen']);

const { t, tm } = useI18n();

const isModalOpen = computed({
  get: () => props.isOpen,
  set: (newState: boolean) => {
    emit('update:isOpen', newState);
  },
});

const handleClose = () => (isModalOpen.value = false);
</script>
